import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_7: FaireProductEntity = {
  token: "caden-lane-7",
  type: "product",
  name: "Sweet Like Candy Double Sided Bamboo Blanket | Blue",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/234e205f5362455f8f90da4ff95706cfc41430b3598d142057c01968c04c26e5.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1798,1798,x0,y0,safe&width=720",
  priceDollars: 24,
  msrpDollars: 48,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_home-decor-bedding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
